export const useRegexEngine = () => {
  const extractTenDigitNumber = (str: string) => {
    const regex = /\d+/g;
    const matches = str.match(regex);
    if (!matches) return [];
    const validNumbers = matches.map((match) => match.replace(/\s/g, ""));
    return validNumbers;
  };
  return {
    extractTenDigitNumber,
  };
};
